// extracted by mini-css-extract-plugin
export default {"marginLeftAuto":"s1qdviNP9bW705hjG4XP","tooltipWidth":"nGAEOPzgqEVrYLr8Thy4","tooltipRow":"m1CTT5DZLwrdOQwZVS6i"};